import React, {lazy, Suspense} from "react"

import Layout from "../components/layout"
import Seo from "../components/seo"
import HomeImage from '../components/homeImage'
const About = lazy(() => import('../components/about'))
const BlogCategories = lazy(() => import('../components/blogCategories'))
const LatestVideos = lazy(() => import('../components/latestVideos'))
// const LatestMusic = lazy(() => import('../components/latestMusic'))
// const IgPosts = lazy(() => import('../components/igPosts'))
const RecentBlog = lazy(() => import('../components/recentBlog'))

const IndexPage = () => (
  <Layout>
    <div>
      <Seo title="Home" path="/" />
      <h1 className="hidden">Home</h1>
      <Suspense fallback={<div>Loading...</div>}>
      <HomeImage />
   </Suspense>
      <Suspense fallback={<div>Loading...</div>}>
      <About />
      </Suspense>
      <Suspense fallback={<div>Loading...</div>}>
      <RecentBlog />
      </Suspense>
      <Suspense fallback={<div>Loading...</div>}>
      <BlogCategories />
      </Suspense>
      <Suspense fallback={<div>Loading...</div>}>
      <LatestVideos />
      </Suspense>
      {/* <LatestMusic /> */}
      {/* <IgPosts /> */}
    </div>
  </Layout>
)

export default IndexPage
